import React from "react";
import FireboardPreAuth from '../FireboardPreAuth'
import classes from "./Body.module.css";
 

export default function Desktop(props) {

  return (
    <div className={classes.container}>
    <FireboardPreAuth {...props} />
    </div>
  );
}
